import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Like = function Like(props) {
  useDeprecatedComponentWarning({
    component: 'Like'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1743 1139q-14 25-17 36-5 16-1 55 7 86-14 158-8 29-23.5 56t-26.5 40.5-31 36.5q-25 27-38 47-6 8-17 38-10 27-17.5 42.5t-25 41.5-45.5 48-68 41q-95 45-232 45h-10q-221 0-423-117-79-47-435-44h-31v-158h30q65-2 140-.5t142 5.5 130.5 19 104.5 39q163 95 344 95 103 3 171-29 36-17 49-33t26-50q14-43 34-73 17-25 52-64 5-6 16.5-19t16.5-18.5 10.5-15 8.5-18.5q12-39 8-98-6-63 5-108 12-49 27-75 29-54 29-90 0-15-2-24.5t-10.5-24-31.5-22-60-7.5h-176q-107 0-179.5-57T1092 690q-9-103 57-230 36-65 35-89-1-28-26-42-39-21-81 4-19 11-81.5 78.5T857 573l-10 12q-35 44-54 67t-54.5 63.5-60.5 63-62 54-71 50-75 37.5-87 29-95 13V802q41-4 79.5-16t68.5-26 64.5-41 57.5-47 57-58.5 52.5-61L723 485l9-13q195-239 267-279 57-32 119-33t117 29q49 26 77 71t31 101q2 31-7 65t-18.5 55-27.5 54q-43 82-38 141 2 30 32.5 46t67.5 16h176q123 0 193.5 62t70.5 172q0 76-49 167z"
  }));
};

Like.displayName = 'Like';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Like.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Like;